import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Plus, HelpCircle, Users, Scan } from 'lucide-react';
import HamburgerMenu from './HamburgerMenu';
import Logo from './Logo';
import { getAuth, getIdToken } from 'firebase/auth';

function Header({ 
  user, 
  onAddCardClick, 
  onBulkUploadClick,
  onFacialRecognitionClick,
  onQuizClick,
  cards = [], 
  groups = [], 
  selectedGroup = null
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const isConnectPage = location.pathname === '/connect';

  const buttonBaseClass = "flex items-center justify-center gap-2 px-6 py-2 text-sm font-medium text-white bg-[#04b53a] rounded hover:bg-[#039431] transition-colors min-w-[168px]";

  async function showUserToken() {
    try {
      const auth = getAuth();
      const token = await getIdToken(auth.currentUser);
      console.log('Your Firebase ID token:', token);
    } catch (error) {
      console.error('Error getting token:', error);
    }
  }

  return (
    <div className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col items-center space-y-4">
          {/* First Row: Logo and Brand */}
          <div className="w-full flex justify-between items-center">
            <div className="flex-1"></div>
            <div className="flex items-center gap-4">
              <Logo className="w-16 h-16" />
              <h2 className="text-3xl font-semibold text-[#04b53a]">Going Green Cards</h2>
            </div>
            <div className="flex-1 flex justify-end">
              <HamburgerMenu 
                onQuizClick={onQuizClick}
                onAddCardClick={onAddCardClick}
                onBulkUploadClick={onBulkUploadClick}
              />
            </div>
          </div>

          {/* Second Row: Welcome Message */}
          {user && (
            <h1 className="text-base text-gray-600">
              Welcome, {user.displayName || 'Guest'}!
            </h1>
          )}

          {/* Third Row: Action Buttons */}
          {user && (
            <div className="flex flex-col sm:flex-row justify-center gap-4 w-full sm:w-auto">
              {isConnectPage ? (
                <button
                  onClick={() => navigate('/')}
                  className={buttonBaseClass}
                >
                  Back to Cards
                </button>
              ) : (
                <>
                  <button
                    onClick={onAddCardClick}
                    className={buttonBaseClass}
                  >
                    <Plus className="w-5 h-5" />
                    Add Card
                  </button>

                  <button
                    onClick={() => onQuizClick(selectedGroup)}
                    className={buttonBaseClass}
                  >
                    <HelpCircle className="w-5 h-5" />
                    Quiz Me
                  </button>

                  <Link to="/connect" className="w-full sm:w-auto">
                    <button className={`${buttonBaseClass} w-full`}>
                      <Users className="w-5 h-5" />
                      Connect
                    </button>
                  </Link>

                  <button
                    onClick={onFacialRecognitionClick}
                    className={buttonBaseClass}
                  >
                    <Scan className="w-5 h-5" />
                    Face Recognition
                  </button>
                </>
              )}
            </div>
          )}

          {process.env.NODE_ENV === 'development' && (
            <button
              onClick={showUserToken}
              className="text-sm text-gray-600 hover:text-gray-800"
            >
              Show Dev Token
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Header; 